module.exports = __webpack_public_path__ + "static/media/food-carton-render.8e83639e.png";